import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a104658b34a0db4d9b87c64861376318fb from "./generated-823bfe34-f3ba-432e-840b-ca9e9e395ed2.json";

import a37f01619af8381f123991f317e9bce1fb from "./generated-8399326b-5a5f-4e63-93dc-d3ef8603e9e1.json";

import a684e9a7e7ce5d8fd7b071b8cca4004fab from "./generated-acac024b-7e75-406f-adc4-5ccbf7d355a0.json";

import a03ad823ba7c8db7c51fdb0a4968675cab from "./generated-a9bf73df-04ad-4a96-a697-cff7781b3bbb.json";

import a73f8cd5305293d35429b06bc75cae3dcb from "./generated-83deea32-fdfa-4d5f-8f7f-bd432171e2f0.json";

import a7c2fa1593e3102aa44c0659b67b5852cb from "./generated-13db297e-5f6d-4831-b21c-96909f841082.json";

import ad8e0de45b57b895c23161e45605b2a46b from "./generated-ea8f3b93-647e-46d5-9e96-39ea24365beb.json";

import a09a20152eca5fa941dd58a43facb9e73b from "./generated-51ef55ba-5983-4b63-a84b-fce12d755826.json";

import aa3206cda4c608d9347579eff2801dd62b from "./generated-a9fb7a72-ce56-4781-b5c5-5258518fa112.json";

import afc9341857dff17d7863715975f34f6acb from "./generated-9edc199d-eff4-468a-8e2b-b8f81b681e47.json";

import ab8a3a04c4fa5d6e6ef734f7f2d5b522eb from "./generated-d478a192-4e56-4678-9c40-ae98f6c98b3f.json";

import abc467e3fb91b9f4ec1e0d84b3fff3d76b from "./generated-bdc0a285-64c6-4ce1-822a-f97f891d9b2f.json";

import a5ef409b348a1280a3192c2bdf2b49e3ab from "./generated-ac9387f1-b10f-45f4-a799-42f4e3c9d13f.json";

import ab2e7d7b2869e32934168edbfb9fefba8b from "./generated-7cf2f3f9-67ca-472c-9028-72d955819367.json";

import af2d2060c9497129fbd60c965553e2134b from "./generated-c96cc0cc-3d0a-442d-8638-c0af38777567.json";

import a5e10992fd9f9be8962222de3007a0050b from "./generated-4ea9f61c-61cf-4685-909d-801215ed2e42.json";

import a037129258055d20bb7da1c8153e2f6b8b from "./generated-659ab832-e50a-4dd0-8d5a-e76c465a3894.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a104658b34a0db4d9b87c64861376318fb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a37f01619af8381f123991f317e9bce1fb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a684e9a7e7ce5d8fd7b071b8cca4004fab);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a03ad823ba7c8db7c51fdb0a4968675cab);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a73f8cd5305293d35429b06bc75cae3dcb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a7c2fa1593e3102aa44c0659b67b5852cb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(ad8e0de45b57b895c23161e45605b2a46b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a09a20152eca5fa941dd58a43facb9e73b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(aa3206cda4c608d9347579eff2801dd62b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(afc9341857dff17d7863715975f34f6acb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(ab8a3a04c4fa5d6e6ef734f7f2d5b522eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(abc467e3fb91b9f4ec1e0d84b3fff3d76b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(aa3206cda4c608d9347579eff2801dd62b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a5ef409b348a1280a3192c2bdf2b49e3ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(ab2e7d7b2869e32934168edbfb9fefba8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(aa3206cda4c608d9347579eff2801dd62b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(af2d2060c9497129fbd60c965553e2134b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a5e10992fd9f9be8962222de3007a0050b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a037129258055d20bb7da1c8153e2f6b8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(af2d2060c9497129fbd60c965553e2134b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */